export default "__VITE_ASSET__BD9PN4vn__"